export default __webpack_public_path__ + "static/media/approved.16c579b1.svg";